import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { OverlayTriggerStateContext, Tab as AriaTab, TabList as AriaTabList, TabPanel as AriaTabPanel, Tabs as AriaTabs } from "react-aria-components";
import { group, tabList, tabPanel, tabText, tabs } from "./Tabs.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const TabStyleContext = /*#__PURE__*/React.createContext({
  type: "normal",
  size: "s",
  fullWidth: false
});
function useInsidePopover() {
  return React.useContext(OverlayTriggerStateContext) != null;
}
const BaseTabs = (t0, ref) => {
  const $ = _c(20);
  let children;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      children,
      type: t1,
      fullWidth: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    children = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const type = t1 === undefined ? "normal" : t1;
  const fullWidth = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "s" : t3;
  const insidePopover = useInsidePopover();
  let t4;
  if ($[6] !== fullWidth || $[7] !== size || $[8] !== type) {
    t4 = {
      type,
      size,
      fullWidth
    };
    $[6] = fullWidth;
    $[7] = size;
    $[8] = type;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const props = t4;
  let t5;
  if ($[10] !== insidePopover) {
    t5 = group({
      insidePopover
    });
    $[10] = insidePopover;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== ref || $[14] !== rest || $[15] !== t5) {
    t6 = /*#__PURE__*/_jsx(AriaTabs, {
      ref: ref,
      ...rest,
      className: t5,
      children: children
    });
    $[12] = children;
    $[13] = ref;
    $[14] = rest;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== props || $[18] !== t6) {
    t7 = /*#__PURE__*/_jsx(TabStyleContext.Provider, {
      value: props,
      children: t6
    });
    $[17] = props;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export const Tabs = /*#__PURE__*/React.forwardRef(BaseTabs);
const BaseTabList = (t0, ref) => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    type,
    size,
    fullWidth
  } = React.useContext(TabStyleContext);
  let t1;
  if ($[0] !== fullWidth || $[1] !== size || $[2] !== type) {
    t1 = tabList({
      type,
      size,
      fullWidth
    });
    $[0] = fullWidth;
    $[1] = size;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== ref || $[6] !== t1) {
    t2 = /*#__PURE__*/_jsx(AriaTabList, {
      ref: ref,
      className: t1,
      children: children
    });
    $[4] = children;
    $[5] = ref;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const TabList = /*#__PURE__*/React.forwardRef(BaseTabList);
function BaseTab(t0, ref) {
  const $ = _c(15);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  const {
    type,
    size,
    fullWidth
  } = React.useContext(TabStyleContext);
  let t1;
  if ($[3] !== fullWidth || $[4] !== size || $[5] !== type) {
    t1 = tabs({
      type,
      size,
      fullWidth
    });
    $[3] = fullWidth;
    $[4] = size;
    $[5] = type;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== children || $[8] !== type) {
    t2 = props => /*#__PURE__*/_jsx("span", {
      className: tabText({
        type
      }),
      children: typeof children === "function" ? children(props) : children
    });
    $[7] = children;
    $[8] = type;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== ref || $[11] !== rest || $[12] !== t1 || $[13] !== t2) {
    t3 = /*#__PURE__*/_jsx(AriaTab, {
      ...rest,
      className: t1,
      ref: ref,
      children: t2
    });
    $[10] = ref;
    $[11] = rest;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}
export const Tab = /*#__PURE__*/React.forwardRef(BaseTab);
const BaseTabPanel = (t0, ref) => {
  const $ = _c(10);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  const insidePopover = useInsidePopover();
  let t1;
  if ($[3] !== insidePopover) {
    t1 = tabPanel({
      insidePopover
    });
    $[3] = insidePopover;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== children || $[6] !== ref || $[7] !== rest || $[8] !== t1) {
    t2 = /*#__PURE__*/_jsx(AriaTabPanel, {
      ...rest,
      className: t1,
      ref: ref,
      children: children
    });
    $[5] = children;
    $[6] = ref;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export const TabPanel = /*#__PURE__*/React.forwardRef(BaseTabPanel);
//# sourceMappingURL=Tabs.js.map